import Logo from "../assets/logo2.png";

const Frame = (props) => {
  return (
    <main className="container-fluid mb-4">
      <div className="container py-4">
        {props.logo && (
          <div className="text-center mb-4">
            <img
              src={Logo}
              alt="Logo Expresso Embaixador"
              width={220}
              className="mb-2"
            />

            <h5 className="fw-bold azul-logo mb-0">FRETAMENTO EBSERH 2026</h5>
          </div>
        )}

        <div className="row justify-content-center">
          <div className="col-sm-12 col-md-10 col-lg-8">
            <section className="card border-0 shadow rounded-3 bg-white">
              {props.title && (
                <div className="card-header bg-white text-center px-4 pt-4 pb-0 border-0">
                  <h5 className="fw-bold mb-0">{props.title}</h5>
                  <hr className="mt-3 mb-0" />
                </div>
              )}

              <div className="card-body p-4">{props.body}</div>

              {props.footer && (
                <div className="card-footer bg-white border-0 px-4 pb-4 pt-0">
                  {props.footer}
                </div>
              )}
            </section>

            {props.copyright && (
              <p className="text-center text-muted small mt-4 mb-0">
                Copyright &copy; 1960-2026 &mdash; Expresso Embaixador LTDA.
              </p>
            )}
          </div>
        </div>
      </div>
    </main>
  );
};

export default Frame;
